import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { DataTableModule } from 'ng-angular8-datatable';
import { TituloPaginasComponent } from './titulo-paginas/titulo-paginas.component';
// import { SelectModule } from 'ng-select';
import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ChartsModule } from 'ng2-charts';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
} from 'ng2-currency-mask/src/currency-mask.config';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMaskModule } from 'ngx-mask';
import { BadgeComponent } from './badge/badge.component';
import { CardProfitabilityComponent } from './card-profitability/card-profitability.component';
import { CardWarningComponent } from './card-warning/card-warning.component';
import { ComentariosmedicaoComponent } from './comentariosmedicao/comentariosmedicao.component';
import { ComentariosnewmedicaoComponent } from './comentariosnewmedicao/comentariosnewmedicao.component';
import { InputComponent } from './input/input.component';
import { ListaVaziaComponent } from './lista-vazia/lista-vazia.component';
import { LoadingComponentComponent } from './loading-component/loading-component.component';
import { MlSelectProviderComponent } from './ml-select-provider/ml-select-provider.component';
import { MlSelectComponent } from './ml-select/ml-select.component';
import { ModalOrdemServicoComponent } from './ordem-servico/modal-ordem-servico/modal-ordem-servico.component';
import { OrdemServicoComponent } from './ordem-servico/ordem-servico.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AbsPipe } from './pipes/abs.pipe';
import { CounterPipe } from './pipes/counter.pipe';
import { ItemPercentagePipe } from './pipes/item-percentage.pipe';
import { PeriodPipe } from './pipes/period.pipe';
import { SingularPipe } from './pipes/singular.pipe';
import { TotalPipe } from './pipes/total.pipe';
import { PrestadorHistoricoPacienteComponent } from './prestador-historico-paciente/prestador-historico-paciente.component';
import { ModalAddCategoryComponent } from './product-form/modal-add-category/modal-add-category.component';
import { ProductFormComponent } from './product-form/product-form.component';
import { MlSelectContractComponent } from './selects/ml-select-contract.component';
import { SwalFireComponent } from './swal-fire/swal-fire.component';
import { ViewMedicaoComponent } from './view-medicao/view-medicao.component';
import { VisualizarMedicaoComponent } from './visualizar-medicao/visualizar-medicao.component';
import { KeysPipe } from './pipes/keys.pipe';
import { KitModule } from '../compras/kit/kit.module';
import { ViewKitComponent } from '../compras/kit/view-kit/view-kit.component';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyALbQdCdjaCL1TalQTj_ApI0YJa60mLbyo',
    }),
    DataTableModule,
    CurrencyMaskModule,
    PdfViewerModule,
    ChartsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxMaskModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ReactiveFormsModule,
  ],
  exports: [
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    TituloPaginasComponent,
    DataTableModule,
    // SelectModule,
    AgmCoreModule,
    CurrencyMaskModule,
    PdfViewerModule,
    NgSelectModule,
    ChartsModule,
    ComentariosmedicaoComponent,
    ComentariosnewmedicaoComponent,
    PrestadorHistoricoPacienteComponent,
    VisualizarMedicaoComponent,
    ViewMedicaoComponent,
    OrdemServicoComponent,
    ModalOrdemServicoComponent,
    InputComponent,
    MlSelectProviderComponent,
    // CalendarModule
    SwalFireComponent,
    ProductFormComponent,
    ModalAddCategoryComponent,
    MlSelectContractComponent,
    CardWarningComponent,
    CardProfitabilityComponent,
    MlSelectComponent,
    BadgeComponent,
    ItemPercentagePipe,
    TotalPipe,
    AbsPipe,
    CounterPipe,
    KeysPipe,
    ViewKitComponent
  ],
  declarations: [
    TituloPaginasComponent,
    ListaVaziaComponent,
    ComentariosmedicaoComponent,
    ComentariosnewmedicaoComponent,
    PrestadorHistoricoPacienteComponent,
    VisualizarMedicaoComponent,
    OrdemServicoComponent,
    ModalOrdemServicoComponent,
    InputComponent,
    PageNotFoundComponent,
    ViewMedicaoComponent,
    SwalFireComponent,
    ComentariosnewmedicaoComponent,
    LoadingComponentComponent,
    MlSelectProviderComponent,
    ProductFormComponent,
    ModalAddCategoryComponent,
    MlSelectContractComponent,
    CardWarningComponent,
    CardProfitabilityComponent,
    MlSelectComponent,
    BadgeComponent,
    ItemPercentagePipe,
    TotalPipe,
    AbsPipe,
    CounterPipe,
    SingularPipe,
    PeriodPipe,
    KeysPipe,
    ViewKitComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
  ],
  entryComponents: [
    PrestadorHistoricoPacienteComponent,
    VisualizarMedicaoComponent,
    ViewMedicaoComponent,
    ModalOrdemServicoComponent,
    LoadingComponentComponent,
    ProductFormComponent,
    ModalAddCategoryComponent,
    ViewKitComponent
  ],
})
export class SharedModule {}
